import * as React from 'react';
import Box from '../../../parts/Box';
import MenuBox from '../../../parts/MenuBox';

import {
    IInputComponentPropsData,
    IInputComponentPropsFunctions,
} from '../props/IInputComponentProps';
import {
    IInputJobSettingsPropsData,
    IInputJobSettingsPropsFunctions,
} from '../props/IInputJobSettingsProps';
import {
    ISummaryComponentPropsData,
    ISummaryComponentPropsFunctions,
} from '../../SummaryPage/props/ISummaryComponentProps';

import CALC from '../interfaces/Calculation';
import {
    Container,
    Col,
    Button,
    Row,
    Form,
    FormGroup,
    Label,
    Input,
    Table,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import IDT from '../interfaces/InputDataType';

type IProps = IInputJobSettingsPropsData &
    IInputJobSettingsPropsFunctions &
    IInputComponentPropsData &
    IInputComponentPropsFunctions &
    IInputComponentPropsFunctions &
    ISummaryComponentPropsData &
    ISummaryComponentPropsFunctions & { history: any };

export default class InputJobSettings extends React.Component<IProps> {
    infoRef = React.createRef<HTMLFormElement>();

    state = {
        aboutBox: false,
        IFbox: false, // input format selection
        MPboxTabs: true,
        SPboxTabs: true,
        button: false,
        grid_box_clicked: false,
        Automated: true,
        User: true,
        UserChoice: true,
        open: true,
        SPforceField: true,
        SPconsensus: true,
        MutationPicker: false,
        SelectedBaseValue: 0,
    };

    bases = [
        'A',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'K',
        'L',
        'M',
        'N',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'V',
        'W',
        'Y',
    ];

    handleSubmit = () => {
        var actIndex = "";
        var actChain = "";

        while(this.props.userDefined.length > 0){
            this.props.userDefined.pop();
        }

        this.props.sPMutations.forEach((value, index, array) => (

            Object.keys(this.props.indexes).map((chain) => (
                Object.keys(this.props.indexes[chain]).map((idx) => (
                    actIndex = Number(idx) == value.position ? this.props.indexes[chain][idx] : actIndex,
                    actChain = Number(idx) == value.position ? chain : actChain
                ))
            )),

            this.props.userDefined.push({
                chain: actChain,
                position: Number(actIndex),
                ref: this.props.sequence.charAt(value.position),
                alt: value.base[0]
            })

        ));
        
        if(this.props.calculation == null){
            alert("Please select either the calculation of automated designs or set up a set of user-defined mutations.");
        }
        else if(this.props.calculation == CALC.Automated){
            if(!this.props.lowRiskDesign && !this.props.highRiskDesign && !this.props.ancestralDesign
            && !this.props.bFactorAnalysis && !this.props.forceFieldMutations && !this.props.consensusMutations){
                alert("Please select at least one analysis.");
            }
            else{
                this.props.submitInput();
            }
        }
        else if(this.props.calculation == CALC.UserDefined){
            if(this.props.userDefined.length == 0){
                alert("Please select at least one mutation to evaluate.");
            }
            else{
                this.props.submitInput();
            }
        }
    };

    handleMPboxTabs = () => {
        localStorage.MPbox = JSON.stringify(false);
        this.setState({
            MPboxTabs: true,
            button: !this.state.button,
        });
    };

    handleSPboxTabs = () => {
        localStorage.MPbox = JSON.stringify(false);
        this.setState({
            SPboxTabs: true,
            button: !this.state.button,
        });
    };

    selectedBase = (value) => () => {
        this.setState({
            SelectedBaseValue: value,
        });
    };

    displaySequenceChain = (props, elements, seq, chain, offset) => {
        for (var i = 0; i < seq.length; ) {
            var tr = [];
            for (; i < seq.length; i++) {
                tr.push(
                    <td>
                        <Button
                            title={this.props.indexes[chain][i + offset]}
                            onClick={this.selectedBase(i + offset)}
                            style={{
                                marginRight: (i + 1) % 5 == 0 && i != 0 ? '1.1em' : '0.3em',
                            }}
                            className={`
                        ${
                                                    (i + offset) == this.state.SelectedBaseValue
                                                        ? 'table-button-selected'
                                                        : 'table-button-unselected'
                                                }
                        ${
                                                    this.has_any_mutations(i + offset, this.props)
                                                        ? 'has-mutation'
                                                        : null
                                                }
                    `}>
                            {i % 25 === 0 ? (
                                <div
                                    style={{
                                        position: 'relative',
                                        top: '20px',
                                        right: '15px',
                                        height: '2px',
                                        fontSize: '11px',
                                    }}>
                                    <button className='indexOfAC'>{this.props.indexes[chain][i + offset]}</button>
                                </div>
                            ) : null}
                            {seq[i]}
                        </Button>
                    </td>
                );
                if ((i + 1) % 25 == 0 && i != 0) {
                    // 25 bases on one line
                    i++;
                    break;
                }
            }
            elements.push(
                <tr>
                    <div>{tr}</div>
                </tr>
            );
        }
        return elements;
    };

    displaySequence = (props, handler) => {
        var elements = [];
        var seq = "";
        var offset = 0;
        var counter = 0;
        //var act = "";
        Object.keys(this.props.indexes).map((chain) => (
            /*Object.keys(this.props.selectedStructureInfo.chainIndex).map((cidx) => (
                this.props.selectedStructureInfo.chainIndex[cidx] === chain ? act = cidx : act = act
            )),*/
            elements.push(
                <tr>
                    <div>CHAIN {chain}</div>
                </tr>
            ),
            seq = "",
            Object.keys(this.props.indexes[chain]).map((idx) => (
                counter++,
                seq += this.props.sequence.charAt(Number(idx)))
            ),
            elements = this.displaySequenceChain(this.props, elements, seq, chain, offset),
            elements.push(<br/>),
            offset += counter,
            counter = 0
        ));

        
        return (
            <table>
                <tbody>{elements}</tbody>
            </table>
        );
    };

    has_any_mutations = (position, props) => {
        return props.sPMutations.some((mutation) => mutation.position === position);
    };

    is_selected = (position, base, props) => {
        return props.sPMutations.some(
            (mutation) => mutation.position === position && mutation.base === base
        );
    };

    is_disabled = (selected_base, mutation_base) => {
        return selected_base === mutation_base;
    };
    displayMutations = (props) => {
        const bases_shorts = [
            'Ala',
            'Cys',
            'Asp',
            'Glu',
            'Phe',
            'Gly',
            'His',
            'Ile',
            'Lys',
            'Leu',
            'Met',
            'Asn',
            'Pro',
            'Gln',
            'Arg',
            'Ser',
            'Thr',
            'Val',
            'Trp',
            'Tyr',
        ];
        const seq = [...props.seq];
        var elements = [];
        for (var i = 0; i < this.bases.length; ) {
            var td = [];
            for (; i < this.bases.length; i++) {
                td.push(
                    <li style={{ marginRight: '1em' }}>
                        <Button
                            style={{
                                width: '7em',
                                height: '2em',
                                padding: '0.1em',
                            }}
                            value={this.bases[i]}
                            onClick={(e) =>
                                this.props.addRemoveMutation(
                                    this.state.SelectedBaseValue,
                                    (e.target as HTMLInputElement).value
                                )
                            }
                            disabled={this.is_disabled(
                                seq[this.state.SelectedBaseValue],
                                this.bases[i]
                            )}
                            className={
                                this.is_selected(
                                    this.state.SelectedBaseValue,
                                    this.bases[i],
                                    this.props
                                )
                                    ? 'icon-box'
                                    : null
                            }>
                            <input
                                type='checkbox'
                                value={this.bases[i]}
                                style={{ opacity: '0' }}
                                // ci sa rovna oznacena base v tabulke s base vo vybere mutacii
                                disabled={this.is_disabled(
                                    seq[this.state.SelectedBaseValue],
                                    this.bases[i]
                                )}
                            />
                            {this.bases[i]} - {bases_shorts[i]}
                        </Button>
                    </li>
                );
                if ((i + 1) % 8 == 0 && i != 0) {
                    // 7 buttons on the line
                    i++;
                    break;
                }
            }
            elements.push(<tr style={{ display: 'flex' }}>{td}</tr>);
        }
        return <ul style={{ paddingLeft: '0' }}>{elements}</ul>;
    };

    transformMap<K, V, R>(
        source: Map<K, V>,
        transformer: (value: V, key: K) => R
    ) {
        return new Map(Array.from(source, (v) => [v[0], transformer(v[1], v[0])]));
    }
    groupBy<K, V>(array: V[], grouper: (item: V) => K) {
        return array.reduce((store, item) => {
            var key = grouper(item);
            if (!store.has(key)) {
                store.set(key, [item]);
            } else {
                store.get(key).push(item);
            }
            return store;
        }, new Map<K, V[]>());
    }

    renderTable = () => {
        let Map = this.transformMap(
            this.groupBy(this.props.sPMutations, (r) => r.position),
            (values) =>
                values.map((obj) => {
                    return obj.base;
                    // <tr>
                    //     <td>{String(obj.position)}</td>
                    //     <td>{this.props.sequence.charAt(obj.position)}</td>

                    //     <td><Button
                    //         value={obj.base}
                    //         onClick={(e) => this.props.addRemoveMutation(obj.position, (e.target as HTMLInputElement).value)}
                    //         >Clear</Button></td>
                    // </tr>
                })
        );

        return Array.from(Map).map(([key, value]) => {
            var actIndex = "";
            var actChain = "";

            Object.keys(this.props.indexes).map((chain) => (
                Object.keys(this.props.indexes[chain]).map((idx) => (
                    actIndex = Number(idx) == key ? this.props.indexes[chain][idx] : actIndex,
                    actChain = Number(idx) == key ? chain : actChain
                ))
            ));

            /*Object.keys(this.props.selectedStructureInfo.chainIndex).map((cidx) => (
                actChain = this.props.selectedStructureInfo.chainIndex[cidx] === actChain ? cidx : actChain
            ));*/

            return (
                <tr>
                    <td>{String(actChain)}</td>
                    <td>{String(actIndex)}</td>
                    <td>{this.props.sequence.charAt(Number(key))}</td>
                    <td>{value.join(', ')} </td>
                    <td>
                        <Button
                            value={key}
                            onClick={(e) => this.props.RemoveMutationsOnPosition(key)}>
                            Clear
                        </Button>
                    </td>
                </tr>
            );
        });
    };

    /*---------------------------------------------------------------------------------------------------------------------------------- */
    render() {
        return (
            <div>
                <Box title='Calculation'>
                    <Container>
                        <Row>
                            <Col
                                className={
                                    this.props.calculation == CALC.Automated
                                        ? 'grid_box_clicked'
                                        : 'grid_box'
                                }>
                                <MenuBox
                                    title='AUTOMATED'
                                    image='/images/input_data/automated.png'
                                    onClick={() =>
                                        this.props.changeCalculation(CALC.Automated)
                                    }></MenuBox>
                            </Col>
                            <Col
                                className={
                                    this.props.calculation == CALC.UserDefined
                                        ? 'grid_box_clicked'
                                        : 'grid_box'
                                }>
                                <MenuBox
                                    title='USER-DEFINED'
                                    image='/images/input_data/userdefined.png'
                                    onClick={() =>
                                        this.props.changeCalculation(CALC.UserDefined)
                                    }></MenuBox>
                            </Col>
                        </Row>
                    </Container>
                </Box>

                {this.props.calculation != CALC.Automated ? null : (
                    <Row>
                        <Col>
                            <Box
                                title='Automated Single-Point'
                                height='30px'
                                onClick={() => this.props.groupAutomatedSinglePoint()}
                                selected={
                                    this.props.forceFieldMutations ||
                                    this.props.bFactorAnalysis ||
                                    this.props.consensusMutations
                                }>
                                <Container>
                                    <MenuBox
                                        height='75px'
                                        className='grid_box'
                                        title='Force-Field Mutations'
                                        image='/images/input_data/forcefield.png'
                                        onClick={() => this.props.toggleForceFieldMutations()}
                                        selected={this.props.forceFieldMutations}></MenuBox>
                                    {this.props.inputDataType === IDT.Sequence ? null : ( // B-factor cannot be optained from Sequence
                                        <MenuBox
                                            height='75px'
                                            className='grid_box'
                                            title='B-Factor Analysis'
                                            image='/images/input_data/bfitter.png'
                                            onClick={() => this.props.toggleBFactorAnalysis()}
                                            selected={this.props.bFactorAnalysis}></MenuBox>
                                    )}
                                    <MenuBox
                                        height='75px'
                                        className='grid_box'
                                        title='Consensus Mutations'
                                        image='/images/input_data/consensus.png'
                                        onClick={() => this.props.toggleConsensusMutations()}
                                        selected={this.props.consensusMutations}></MenuBox>
                                </Container>
                            </Box>
                        </Col>
                        <Col>
                            <Box
                                title='Automated Multiple-Point'
                                height='30px'
                                onClick={() => this.props.groupAutomatedMultiplePoint()}
                                selected={
                                    this.props.lowRiskDesign ||
                                    this.props.highRiskDesign ||
                                    this.props.ancestralDesign
                                }>
                                <Container>
                                    <MenuBox
                                        height='75px'
                                        className='grid_box'
                                        title='Low-Risk Design'
                                        image='/images/input_data/lowrisk.png'
                                        onClick={() => this.props.changeLowRiskDesign()}
                                        selected={this.props.lowRiskDesign}></MenuBox>
                                    <MenuBox
                                        height='75px'
                                        className='grid_box'
                                        title='High-Risk Design'
                                        image='/images/input_data/highrisk.png'
                                        onClick={() => this.props.changeHighRiskDesign()}
                                        selected={this.props.highRiskDesign}></MenuBox>
                                    <MenuBox
                                        height='75px'
                                        className='grid_box'
                                        title='Ancestral Design'
                                        image='/images/input_data/ancestrals.png'
                                        onClick={() => this.props.changeAncestralDesign()}
                                        selected={this.props.ancestralDesign}></MenuBox>

                                        {this.props.ancestralDesign && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '250px',
                                                left: '41px',
                                                backgroundColor: '#ffe58f',
                                                border: '1px solid #ccc',
                                                borderRadius: '8px',
                                                padding: '12px 30px',
                                                boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
                                                zIndex: 10,
                                                width: '410px',
                                            }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <span style={{ textAlign: 'center', fontSize: '12px', color: '#333' }}>
                                                        Enabling Ancestral Design features may increase computational time.
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                </Container>
                            </Box>
                        </Col>
                    </Row>
                )}

                {this.props.calculation != CALC.UserDefined ? null : (
                    <Box title='Mutations' button={true}>
                        <Container
                            style={{
                                paddingLeft: '0',
                            }}>
                            <this.displaySequence seq={this.props.sequence} />
                            <h1>Select mutation/s for chosen base</h1>
                            <Button
                                style={{
                                    width: '7em',
                                    height: '2em',
                                    padding: '0.1em',
                                    marginLeft: '0',
                                }}
                                onClick={(e) =>
                                    this.props.AddAllMutationsOnPosition(
                                        this.state.SelectedBaseValue,
                                        this.props.sequence.charAt(this.state.SelectedBaseValue)
                                    )
                                }>
                                <input
                                    type='checkbox'
                                    style={{ opacity: '0' }}
                                    // ci sa rovna oznacena base v tabulke s base vo vybere mutacii
                                />
                                Select all
                            </Button>
                            <this.displayMutations seq={this.props.sequence} />
                        </Container>
                        <Container>
                            <Table>
                                <thead style={{ background: '#A6A6A678', textAlign: 'center' }}>
                                    <tr>
                                        <th>Chain</th>
                                        <th>Position</th>
                                        <th>Wild-type</th>
                                        <th>Mutations</th>
                                        <th>Clear</th>
                                    </tr>

                                    {this.renderTable()}
                                </thead>
                            </Table>
                        </Container>
                    </Box>
                )}

                <div className='ll-button-group'>
                    <Button size='lg' onClick={this.props.goBack}>
                        Back
                    </Button>
                    <Button
                        style={{ marginLeft: '5px' }}
                        size='lg'
                        onClick={this.handleSubmit}>
                        Next
                    </Button>
                </div>
            </div>
        );
    }
}
